<template>
    <span>
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16"><path fill="currentColor" d="M0 15h15v1H0zm0-4h3v3H0zm4-2h3v5H4zm4-4h3v9H8zm4-5h3v14h-3z"/></svg>
    </span>
</template>
